import React, { useMemo } from "react";
import { useChannel, useExternalUsers } from "../../hooks";
import Avatar from "../Avatar/Avatar";
import S from "./Header.styled";
const Header = () => {
    var _a, _b;
    const channel = useChannel();
    const users = useExternalUsers();
    const [channelName, channelImage] = useMemo(() => {
        var _a;
        if (channel.channelType === "public")
            return [channel.name, undefined];
        const person = channel.members.find((member) => member.id !== channel.currentUserId);
        if (channel.channelType === "restricted") {
            return [channel.data.name, person === null || person === void 0 ? void 0 : person.image];
        }
        if (person === null || person === void 0 ? void 0 : person.name) {
            return [person.name, person.image];
        }
        const externalId = (_a = channel.data.members) === null || _a === void 0 ? void 0 : _a.find((id) => id !== channel.currentUserId);
        const externalPerson = externalId ? users.get(externalId) : undefined;
        if (externalPerson) {
            return [externalPerson.name, externalPerson.image];
        }
        return [channel.name, undefined];
    }, [users, channel]);
    return (React.createElement(S.Wrapper, null,
        React.createElement(S.Container, null,
            channel.channelType !== "public" ? (React.createElement(React.Fragment, null,
                React.createElement(Avatar, { src: channelImage, alt: channelName !== null && channelName !== void 0 ? channelName : "" }),
                channel.channelType === "restricted" && (React.createElement(S.NumberOfMembersIcon, null, (_b = (_a = channel.data.members) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0)))) : null,
            React.createElement(S.Text, null,
                "# ",
                channelName))));
};
export default Header;
//# sourceMappingURL=Header.js.map